<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11"><path fill="currentColor" d="M9.59 8.54H1.4a1 1 0 0 1-.7-1.7l4.08-4.09a1 1 0 0 1 1.42 0l4.08 4.09a1 1 0 0 1-.7 1.7z"/></svg>
